import { render, staticRenderFns } from "./BrbLabelValue.vue?vue&type=template&id=6860789b&"
import script from "./BrbLabelValue.vue?vue&type=script&lang=js&"
export * from "./BrbLabelValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6860789b')) {
      api.createRecord('6860789b', component.options)
    } else {
      api.reload('6860789b', component.options)
    }
    module.hot.accept("./BrbLabelValue.vue?vue&type=template&id=6860789b&", function () {
      api.rerender('6860789b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbLabelValue.vue"
export default component.exports